var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$store.state.meta.title || '壹心理咨询'),expression:"$store.state.meta.title || '壹心理咨询'"}]},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }